import { useEffect } from 'react'
import { gql, useQuery } from '@apollo/client'
import { useFeatureFlags, flags } from 'lib/feature-flags'
import { amplitudeEvent } from 'lib/amplitude'

const GET_PAYMENT_ACCOUNT_SETUP_REDIRECT_URL = gql`
  query paymentAccountSetup(
    $accountName: String
    $redirect: PaymentAccountRedirectType
  ) {
    paymentAccountSetup(accountName: $accountName, redirect: $redirect) {
      oauthLink
    }
  }
`

const GET_PAYMENT_ACCOUNT_SETUP_REDIRECT_URL_WITH_LINK = gql`
  query paymentAccountLinkSetup(
    $accountName: String
    $returnUrl: String!
    $accountId: String
  ) {
    paymentAccountLinkSetup(
      accountName: $accountName
      returnUrl: $returnUrl
      accountId: $accountId
    ) {
      accountLink
    }
  }
`

const StripeAccountSetupRedirect = ({ accountName, accountId }) => {
  const [isPaymentAccountLinkEnabled] = useFeatureFlags([
    flags.FLAG_ACCOUNT_SETUP_PAYMENT_LINKS,
  ])

  const { data: dataWithoutLink } = useQuery(
    GET_PAYMENT_ACCOUNT_SETUP_REDIRECT_URL,
    {
      variables: { accountName, redirect: 'MY_PGA' },
      skip: isPaymentAccountLinkEnabled,
    },
  )

  const { data: dataWithLink } = useQuery(
    GET_PAYMENT_ACCOUNT_SETUP_REDIRECT_URL_WITH_LINK,
    {
      variables: {
        accountName,
        returnUrl: window.location.origin + window.location.pathname,
        accountId,
      },
      skip: !isPaymentAccountLinkEnabled,
    },
  )

  const data = isPaymentAccountLinkEnabled ? dataWithLink : dataWithoutLink

  useEffect(() => {
    const path = window.location.pathname
    const source = path?.includes('junior-league')
      ? 'JRL'
      : path.includes('family-golf')
        ? 'FG'
        : 'Coach'
    if (accountId) {
      amplitudeEvent('refreshed-payment-account-onboarding', {
        source,
        url: window.location.href,
        path: path,
      })
    }
  }, [accountId])

  useEffect(() => {
    const redirectUrl = isPaymentAccountLinkEnabled
      ? data?.paymentAccountLinkSetup?.accountLink
      : data?.paymentAccountSetup?.oauthLink

    if (redirectUrl) {
      window.location = redirectUrl
    }
  }, [data, isPaymentAccountLinkEnabled])
  return null
}

export default StripeAccountSetupRedirect
